type ConsentState = {
  analytics_storage: "granted" | "denied"
  ad_storage: "granted" | "denied"
  ad_user_data: "granted" | "denied"
  ad_personalization: "granted" | "denied"
}

const CONSENT_KEY = "COOKIE_CONSENT_STATE"
const GA4_ID = import.meta.env.REACT_APP_GA4_MEASUREMENT_ID as string

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function gtag(...args: any[]) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(args)
}

/** Load GA4 + Consent Mode defaults. Safe to call multiple times. */
export function initGA4(): void {
  if (document.getElementById("ga4-script")) return

  // Expose gtag globally
  window.gtag = function () {
    window.dataLayer = window.dataLayer || []
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments)
  }

  // Consent Mode v2 defaults — must come before gtag config
  gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
  })
  gtag("set", "url_passthrough", true)
  gtag("set", "ads_data_redaction", true)

  // Load gtag.js
  if (GA4_ID) {
    const script = document.createElement("script")
    script.id = "ga4-script"
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`
    document.head.appendChild(script)

    gtag("js", new Date())
    gtag("config", GA4_ID)
  }
}

export function getSavedConsent(): ConsentState | null {
  try {
    const raw = localStorage.getItem(CONSENT_KEY)
    if (!raw) return null
    return JSON.parse(raw) as ConsentState
  } catch {
    return null
  }
}

export function hasConsentDecision(): boolean {
  return getSavedConsent() !== null
}

function saveConsent(state: ConsentState): void {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(state))
  } catch {
    // ignore
  }
}

export function updateGoogleConsent(state: ConsentState): void {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: state.analytics_storage,
      ad_storage: state.ad_storage,
      ad_user_data: state.ad_user_data,
      ad_personalization: state.ad_personalization,
    })
  }
}

export function acceptAllConsent(): void {
  const state: ConsentState = {
    analytics_storage: "granted",
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
  }
  saveConsent(state)
  updateGoogleConsent(state)
}

export function rejectAllConsent(): void {
  const state: ConsentState = {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  }
  saveConsent(state)
  updateGoogleConsent(state)
}
